import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { QueryOptions } from 'src/libs/react-query';
import { userKeys } from './user-keys';
import { useAuth } from 'src/libs/rainbow';

export interface GetWithdrawalRevokePreviewParams {
  tokenId: string;
  amount: number;
}

export interface GetWithdrawalRevokePreviewResponse {
  will_revoke: boolean;
  revoke_amount: number;
  min_balance_for_reward: number;
}

export const getWithdrawalRevokePreview = async (
  params: GetWithdrawalRevokePreviewParams,
) => {
  const { data } = await apiClient.get<GetWithdrawalRevokePreviewResponse>(
    '/v2/users/withdrawals/revoke-preview',
    {
      params: {
        tokenId: params.tokenId,
        amount: params.amount,
      },
    },
  );
  return data;
};

export type UseGetWithdrawalRevokePreviewOptions<TError, TContext> = QueryOptions<
  GetWithdrawalRevokePreviewResponse,
  TError,
  GetWithdrawalRevokePreviewResponse,
  ReturnType<typeof userKeys.allWithdrawalRevokePreview>
>;

export const useGetWithdrawalRevokePreview = <TError = Error, TContext = unknown>(
  params: GetWithdrawalRevokePreviewParams,
  options?: UseGetWithdrawalRevokePreviewOptions<TError, TContext>,
) => {
  const { isAuthenticated, isEthereumWallet } = useAuth();
  return useQuery({
    queryKey: userKeys.allWithdrawalRevokePreview(params),
    queryFn: () => getWithdrawalRevokePreview(params),
    enabled: isAuthenticated && isEthereumWallet && options?.enabled !== false,
    ...options,
  });
};
